module.exports = __webpack_public_path__ + "img/teaching1.e672cd4b.png";